export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14116.5a65dcf1.jpg";